import React, { useCallback } from 'react';
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  useNotify,
} from 'react-admin';
import { Box, Card, CardContent } from '@mui/material';

import ColorPicker from '../layout/ColorPicker';
import errorNotification from '../../utilities/errorNotification';

const TagCreate = () => {
  const notify = useNotify();

  const onError = useCallback((e: unknown) => {
    notify(errorNotification(e), { type: 'error' });
  }, [notify]);

  return (
    <Create mutationOptions={{ onError }}>
      <Card variant="outlined">
        <CardContent>
          <SimpleForm defaultValues={{ color: '#000000' }} component={Box}>
            <TextInput validate={required()} source="name" />
            <ColorPicker source="color" label="Color" />
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default TagCreate;
